import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {CountdownPipe} from "../../core/pipes/countdown/countdown";
import { NgClass } from "@angular/common";
import {CountdownWithSecondsPipe} from "../../core/pipes/countdown/countdown-with-seconds";

@Component({
  selector: 'app-countdown',
  standalone: true,
  imports: [
    CountdownPipe,
    NgClass,
    CountdownWithSecondsPipe
],
  templateUrl: './countdown.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './countdown.component.scss'
})
export class CountdownComponent implements OnInit{
  @Input()
  eventClosed: boolean = false;

  @Input()
  deadline!: Date;

  timeLeft: number = 0;

  @Input()
  withSeconds: boolean = false;

  @Input()
  timeout: number = 60000 // One minute

  ngOnInit() {
    this.timeLeft = this.calculateTimeLeft(this.deadline);
    setInterval(() => {
    this.timeLeft = this.calculateTimeLeft(this.deadline)
    }, this.timeout);
  }

  calculateTimeLeft(deadline: Date): number {
    const now = new Date().getTime();
    const eventTime = new Date(deadline).getTime();
    // Convert milliseconds to hours
    return (eventTime - now) / (1000 * 60 * 60);
  }


}
